import {http} from "@/assets/utils/api";

/**
 * 获取字典值
 * @param dictType
 * @param config
 */
export const dictList = (dictType, config) => http.get('/system/dict/data/list', Object.assign({params:{
        dictType,
        pageSize: 999
    }}, config));

/**
 * 测试接口
 * @param params
 * @param config
 */
export const testGet = (params, config) => http.get('/test/index/', Object.assign({}, config));

/**
 * 测试接口
 * @param form
 * @param config
 */
export const testPost = (form, config) => http.post('/test/index/', form, Object.assign({}, config));

/**
 * 获取字典项
 * @returns 
 */
export const getDictList = (params) => http.get('/dict/getSelect',{params,custom:{isAuth:false}});

/**
 * 年级学段查询
 */
export const getGrade = () => http.get('/yymCourseGrade/getAll',{custom:{isAuth:false}});

/**
 * 年级学段查询
 */
export const getSubject = (params) => http.get('/yymCourseSubject/getAll',{params,custom:{isAuth:false}});

/**
 * 学期查询
 */
export const getTerm = (params) => http.get('/yymCourseTerm/getAll',{params,custom:{isAuth:false}});

/**
 * 版本查询
 */
export const getPublisher = (params) => http.get('/yymCoursePublisher/getAll',{params,custom:{isAuth:false}});

/**
 * 教材查询
 */
export const getTextbook = () => http.get('/yymCourseTextbook/getAll',{custom:{isAuth:false}});

/**
 * 课程难度查询
 */
export const getDifficulty = () => http.get('/yymCourse/courseDifficulty',{custom:{isAuth:false}});

/**
 * 文件上传
 */
export const uploadFile = (data) => http.post('/file/upload',data,{custom:{isAuth:false,isTimeout:true}});

/**
 * 热门搜索关键词
 */
export const getHotSearch = (params) => http.get('/yymCourseHotSearch/hotKeywords',{params,custom:{isAuth:false}});

/**
 * @param {*} params id:ID 编号逆熵家长赢-首页：5   冠军专家辅导课-首页 ：3   冠军专家辅导课-课程详情左：4   冠军专家辅导课-课程详情右：7
 * @returns 
 */
export const getBannerList = (params) => http.get('/info/carousel',{params,custom:{isAuth:false}});

/**
 * 反馈
 * @param {*} data 
 * @returns 
 */
export const addFeedBack = (data) => http.post('/yymFeedback/add',data);

/**
 * 课程类型
 */
export const getCourseType = (params) => http.get('/yymCourseType/getAll',{params});

/**
 * 文件上传（带进度监听）
 */
export const uploadFileWithProgress = (data, onProgress) => http.uploadWithProgress(
    '/file/upload', 
    data, 
    onProgress, 
    {custom: {isAuth: false, isTimeout: true}}
);

/**
 * 常见问题分类
 */
export const getNormalQuestionList = (params) => http.get('/yymHelpFaq/front',{params,custom:{isAuth:false}});

/**
 * 获取客服
 */
export const getCustomerList = (data) => http.post('/customerServiceConfiguration/getAllConfiguration',data);

/***
 * 客服二维码
 */
export const getCustomerCode = () => http.get('/customerServiceConfiguration/getAllCode');

/**
 * 根据父节点id查询子级字典数据列表
 */
export const getChildsDict = (params) => http.get('/dict/getChilds/list',{params});